interface Props {
  onStartFree: () => void;
  onGoPro: () => void;
}

export function Hero({ onStartFree, onGoPro }: Props) {
  return (
    <section className="lp-hero" id="main" aria-labelledby="hero-heading">
      <p className="lp-hero__eyebrow">INVITATION-ONLY BETA · 2026</p>
      <h1 className="lp-hero__heading" id="hero-heading">
        The AI system that builds your<br />
        Orchestration Design Canvas with you.
      </h1>
      <p className="lp-hero__sub">
        What the authors would do if they could sit in the room with every reader.
        Upload your documents, process maps, or deployment plans — and work through
        the six layers of the Canvas, one precise question at a time.
      </p>
      <div className="lp-hero__ctas">
        <button className="btn btn--primary btn--large" onClick={onStartFree}>
          Start free →
        </button>
        <button className="btn btn--ghost btn--large" onClick={onGoPro}>
          Go Pro — $149/mo
        </button>
      </div>
    </section>
  );
}
